import { TMemberCare } from '@/types/MemberCare.types';
import { api, TCustomAxiosResponse } from '..';
import { INFINITE_SCROLL_CARDS_PER_PAGE } from '@/constants';
import { apiPaths } from '@/services/api/paths';

export const getMyOrganizationMemberCares = async (
  page: number,
  limit = INFINITE_SCROLL_CARDS_PER_PAGE,
): Promise<TCustomAxiosResponse<TMemberCare[]>> => {
  const { data } = await api.get(apiPaths.memberCare.myOrganizationMemberCares, { params: { page, limit } });

  return data;
};
